export const CAMP_MEMBERS = [
  {
    id: 'kimmo',
    name: 'Kimmo',
    role: 'Den Galna Visionären',
    description: 'Ser inga begränsningar, bara möjligheter. Driver artcaren framåt med ren vilja, skratt och kaos.',
    quote: 'Om något känns omöjligt — Kimmo gör det ändå.',
    dream: 'Att bygga en artcar som flyger',
    longing: 'Ökennätter som aldrig tar slut',
    secret: 'Gråter till soluppgångar',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/wc6cknw6_Kimmo.png',
    color: '#FF007F',
    gridClass: 'md:col-span-4 md:row-span-2',
  },
  {
    id: 'lisa',
    name: 'Lisa',
    role: 'Stillheten i Stormen',
    description: 'Hjärtat i campet. Hon håller allt samman, ser alla, bär allt.',
    quote: 'Men när natten faller… vaknar något annat. Och då är det ingen som riktigt vet vad som händer.',
    dream: 'Att dansa i mörkret utan att tänka',
    longing: 'Tystnad mitt i stormen',
    secret: 'Har ett hemligt altare i öknen',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/y3yxc70y_Lisa_BL_.png',
    color: '#00F0FF',
    gridClass: 'md:col-span-4 md:row-span-1',
  },
  {
    id: 'markus',
    name: 'Markus',
    role: 'Samlaren av Själar',
    description: 'En ledare utan att försöka. Hans liv är ett äventyr – och han bjuder in andra att följa med.',
    quote: 'Han bygger flockar, och de blir familj.',
    dream: 'Att samla alla han älskar på samma plats',
    longing: 'Känslan av att komma hem till flocken',
    secret: 'Skriver brev han aldrig skickar',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/74n2r4uz_Markus_BL_.png',
    color: '#9D4CDD',
    gridClass: 'md:col-span-4 md:row-span-1',
  },
  {
    id: 'clara',
    name: 'Clara',
    role: 'Ren Energi',
    description: 'Ren närvaro. Ett leende som öppnar världar.',
    quote: 'Vild, vacker, levande – som om hon alltid är mitt i sitt bästa ögonblick.',
    dream: 'Att vakna varje morgon och känna frihet',
    longing: 'Solnedgångar med vänner',
    secret: 'Sjunger bara när ingen hör',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/uzlvt594_Clara.png',
    color: '#FF007F',
    gridClass: 'md:col-span-8 md:row-span-2',
  },
  {
    id: 'linus',
    name: 'Linus',
    role: 'Bus & Visioner',
    description: 'Alltid något på gång. Alltid nästa steg.',
    quote: 'Som ett barn med en vision – och ett hjärta som aldrig tvekar.',
    dream: 'Att göra det omöjliga möjligt',
    longing: 'Skratt som ekar genom natten',
    secret: 'Planerar alltid tre steg framåt',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/q1yw5i9q_Linus_BL_.png',
    color: '#39FF14',
    gridClass: 'md:col-span-4 md:row-span-1',
  },
  {
    id: 'lina',
    name: 'Lina',
    role: 'Skratt som Smittar',
    description: 'Energi som lyfter. Dansar genom livet och drar med sig alla.',
    quote: 'När Lina är där → händer något.',
    dream: 'En oändlig dansparty under stjärnorna',
    longing: 'Känslan av total närvaro',
    secret: 'Drömmer om att flyga',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/x8mel88c_Lina_BL_.JPG',
    color: '#00F0FF',
    gridClass: 'md:col-span-4 md:row-span-2',
  },
  {
    id: 'anton',
    name: 'Anton',
    role: 'DJ / Kontrollerad Energi',
    description: 'Total närvaro. När han spelar finns inget annat.',
    quote: 'Han bygger vibe – och lever i den.',
    dream: 'Att skapa det perfekta DJ-settet under stjärnorna',
    longing: 'Ögonblicket när beaten droppar och alla lyfter',
    secret: 'Kompor musik i hemlighet kl 3 på natten',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/cvemajhf_Anton_BL_.png',
    color: '#9D4CDD',
    gridClass: 'md:col-span-4 md:row-span-1',
  },
  {
    id: 'sophie',
    name: 'Sophie',
    role: 'Mjuk Kraft',
    description: 'Magnetisk närvaro. En blick som får tiden att sakta ner.',
    quote: 'Hon öppnar rummet utan att säga ett ord.',
    dream: 'Att fånga ett ögonblick och leva i det för evigt',
    longing: 'Djupa samtal under stjärnhimlen',
    secret: 'Målar i hemlighet varje natt',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/v7g521h2_Sophie_BL_.png',
    color: '#FF007F',
    gridClass: 'md:col-span-4 md:row-span-1',
  },
  {
    id: 'maxine',
    name: 'Maxine',
    role: 'Gyllene Kraft',
    description: 'Solens dotter. Glitter i huden och guld runt halsen.',
    quote: 'Hon lyser upp öknen utan att ens försöka.',
    dream: 'Att dansa tills solen går upp och sen dansa lite till',
    longing: 'Ögonblicket när allt faller på plats',
    secret: 'Skriver kärleksbrev till universum',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/095f7qq0_ChatGPT%20Image%20Jul%205%2C%202026%2C%2009_57_53%20AM.png',
    avatarPosition: '0% 20%',
    avatarScale: 2,
    color: '#FFD700',
    gridClass: 'md:col-span-4 md:row-span-1',
  },
  {
    id: 'marcus',
    name: 'Marcus',
    role: 'Solens Krigare',
    description: 'Ett leende som kunde starta en revolution. Styrka och värme i perfekt balans.',
    quote: 'Han behöver inte prata högt. Hans närvaro gör det åt honom.',
    dream: 'Att bygga något som varar längre än natten',
    longing: 'Den där känslan precis innan beaten droppar',
    secret: 'Mediterar i hemlighet vid soluppgången',
    avatar: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/095f7qq0_ChatGPT%20Image%20Jul%205%2C%202026%2C%2009_57_53%20AM.png',
    avatarPosition: '100% 20%',
    avatarScale: 2,
    color: '#FF6B35',
    gridClass: 'md:col-span-4 md:row-span-1',
  }
];

export const MUSIC_TRACKS = {
  landing: {
    name: 'Time To Dance (feat. Norma Jean Martine)',
    url: 'https://customer-assets-39nsmqrw.emergentagent.net/job_borderland-camp/artifacts/73h57zkc_01%20Time%20To%20Dance%20%28feat.%20Norma%20Jean%20Martine%29.m4a',
    startAt: 28,
  },
  camp: {
    name: 'Die immer lacht (feat. Kerstin Ott)',
    url: 'https://customer-assets-39nsmqrw.emergentagent.net/job_borderland-camp/artifacts/s91pivu1_01%20Die%20immer%20lacht%20%28feat.%20Kerstin%20Ott%29%20%5BRadio%202016%20Mix%5D.m4a',
    startAt: 29,
  }
};

export const HERO_VIDEO_URL = 'https://customer-assets.emergentagent.com/job_c0af43b2-0c20-4bb2-9254-0807f483f404/artifacts/kjb8yk03__users_bbbf527f-345b-4fdb-bb61-9ce06df68e15_generated_82463b67-3c27-4d3e-ad11-f0a45e12f0eb_generated_video.MP4';

export const TECHNO_TRACK = {
  name: 'ZISO - Face Card Never Decline',
  url: 'https://customer-assets.emergentagent.com/job_borderland-camp/artifacts/digcw5pg_ZISO%20-%20Face%20Card%20Never%20Decline.mp3'
};

// Oktober Fest - 26 september 2026
export const FEST_DATE = new Date('2026-09-26T18:00:00');

export const FEST_INFO = {
  title: 'MUY COMPLICADO OKTOBER FEST',
  date: '26 september 2026',
  time: '18:00 till sent',
  location: 'Torpvägen 20, 147 63 Uttran',
  hosts: ['Kimmo', 'Lisa'],
  sleep: true,
};

export const CAMP_QUOTES = [
  { text: "Be yourself; everyone else is already taken.", author: "Oscar Wilde" },
  { text: "The only way to deal with an unfree world is to become so absolutely free that your very existence is an act of rebellion.", author: "Albert Camus" },
  { text: "You are the universe experiencing itself.", author: "Alan Watts" },
  { text: "We are all in the gutter, but some of us are looking at the stars.", author: "Oscar Wilde" },
  { text: "The meaning of life is just to be alive. It is so plain and so obvious and so simple.", author: "Alan Watts" },
  { text: "Out beyond ideas of wrongdoing and rightdoing, there is a field. I'll meet you there.", author: "Rumi" },
  { text: "To live is the rarest thing in the world. Most people exist, that is all.", author: "Oscar Wilde" },
  { text: "You didn't come into this world. You came out of it, like a wave from the ocean.", author: "Alan Watts" },
  { text: "And those who were seen dancing were thought to be insane by those who could not hear the music.", author: "Nietzsche" },
  { text: "The wound is the place where the Light enters you.", author: "Rumi" },
  { text: "I am not what happened to me. I am what I choose to become.", author: "Carl Jung" },
  { text: "Set your life on fire. Seek those who fan your flames.", author: "Rumi" },
  { text: "Life shrinks or expands in proportion to one's courage.", author: "Anaïs Nin" },
  { text: "The only people for me are the mad ones, the ones who never yawn or say a commonplace thing.", author: "Jack Kerouac" },
  { text: "Muddy water is best cleared by leaving it alone.", author: "Alan Watts" },
  { text: "What is a man but the sum of his memories? We are the stories we live.", author: "Desmond Miles" },
  { text: "You must have chaos within you to give birth to a dancing star.", author: "Nietzsche" },
  { text: "The desire to reach for the stars is ambitious. The desire to reach hearts is wise.", author: "Maya Angelou" },
];
